module.exports = __webpack_public_path__ + "offer-request-rieltor.90c86488e554722280b6ee013b9c89fa.png";